import { createContext } from "react";
import { IEnvConfig } from "../types/auth";
import { makeVar } from "@apollo/client";
import { IMessage } from "../types/common";

const envConfig: IEnvConfig = {
    tenant: '',
    clientId: '',
    applicationInsightsConnectionString: ''
}

export const EnvContext = createContext(envConfig)

export const warn = makeVar<IMessage>({
    title: '',
    content: ''
})

export const announce = makeVar<string>('')

export const longIdle = makeVar<number>(0)